import { BCT, DataContainerAppilier, OTracking, TrackingData } from "./types/tracking";
import { TrackSessionStart } from "./tracking/SessionStart";

/*🤫
🤫
🤫
🤫*/

let bct: BCT;
export let _isInitialized: boolean | undefined;

export function isInitialized(): boolean | undefined {
  return _isInitialized;
}

/*🤫
🤫
🤫
🤫
🤫
🤫*/
export function submitToTracking(dataContainer: TrackingData, fn: DataContainerAppilier, type: string) {
  try {
    fn(dataContainer);
    window.o_global.debug.warn(type + " submitting " + JSON.stringify(dataContainer));
  } catch (e) {
    window.o_global.debug.warn(e + "");
  }
}

/*🤫
🤫
🤫
🤫*/
export function sendTrackingDataForNextPI(trackingData: TrackingData) {
  if (bct && typeof bct.trackOnNextPageImpression === "function") {
    submitToTracking(trackingData, bct.trackOnNextPageImpression, "Track on next PI");
  }
}

/*🤫
🤫
🤫
🤫*/
export function sendEventToTracking(dataContainer: TrackingData) {
  if (bct && typeof bct.sendEventToTrackingServer === "function") {
    submitToTracking(dataContainer, bct.sendEventToTrackingServer, "Track event");
  }
}

export function readTrackingFromStorage() {
  let trackingKey: string | null;
  const storage = new window.o_global.Storage(() => window.sessionStorage);

  if (storage.isAvailable) {
    trackingKey = storage.getItem("squirrel_searchTracking");
    if (Boolean(trackingKey).valueOf()) {
      storage.removeItem("squirrel_searchTracking");
      sendEventToTracking(JSON.parse(trackingKey as string));
    }
  }
}

export function init(otracking: OTracking) {
  /*🤫*/
  bct = otracking.bct;

  readTrackingFromStorage();

  _isInitialized = true;
}

export interface Tracking {
  isInitialized: () => boolean | undefined;
  init: typeof init;
  sendEventToTracking: typeof sendEventToTracking;
  sendTrackingDataForNextPI: typeof sendTrackingDataForNextPI;
}

export const tracking = { isInitialized, init, sendEventToTracking, sendTrackingDataForNextPI };

window.o_global &&
  window.o_global.eventLoader.onReady(1, () => {
    /*🤫*/
    if (window.squirrelTrackingInitialized) {
      return;
    }
    window.squirrelTrackingInitialized = true;

    if (bct) {
      init(window.o_tracking);
    } else {
      window.o_global.eventLoader.onLoad(1, () => {
        TrackSessionStart.init();
        init(window.o_tracking);
      });
    }
  });
